import MainSearch from 'components/Search/MainSearch';
import React from 'react';

const InsidersGuides: React.FC = () => {
  return (
    <section className="bg-center bg-no-repeat bg-cover bg-guides-bg-img h-[358px] md:h-[388px] lg:h-[503px]">
      <div className="container my-6 mt-[66px] pl-[20px] text-14-26-0.3 lg:pt-1 lg:pb-2">
        <div className="pt-[62px] md:pt-[32px] pb-16 md:pb-24 lg:pt-[106px] lg:pb-36 md:pl-[95px] lg:pl-[153px] md:w-[700px] xl:w-[1040px]">
          <h2 className="text-23-29-0.3 md:text-23-29-0.3 tracking-[0.77px] md:tracking-[0.77px] uppercase lg:text-30-47-1 pt-[14px] lg:pt-0 md:pl-[48px] lg:pl-28 font-sohneBreitHalbfett md:w-[60%] lg:w-[100%]">
            The insider's guide to Miami condos
          </h2>
          <p className="text-14-26-0.3 md:text-16-26-0.3 mt-[13px] md:mt-[23px] lg:mt-[23px] mb-[34px] md:mb-[38px] lg:my-10 md:pl-12 md:w-[403px] lg:w-[470px] lg:pl-28">
            Find the right condo in the perfect neighborhood
          </p>
          <div className="flex flex-col font-sohneKraftig">
            <MainSearch noScroll={true} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default InsidersGuides;
